/**
 * @generated SignedSource<<87263cf09a9d17f43b12388d04dc313a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MapEventMarkers_map",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "markersMaxClusterRadius",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "MapElementEvent",
      "kind": "LinkedField",
      "name": "events",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "MapEventMarker_element"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Map",
  "abstractKey": "__isMap"
};

node.hash = "1deb3f9c5b828a5492a61e1861b1e46e";

module.exports = node;
